import React from "react";
import { Button } from "@showitinc/showit-wc";
import cx from "classnames";
import styles from "./ContextMenuWrapper.module.css";

/**
 * Context Button
 *
 * @component
 * @param {Object} props
 * @param {string=} props.icon - string name for menu button icon
 * @param {Function=} props.onClick - click action
 * @param {string=} props.className - extra classnames to apply to the context button
 */
const ContextButton = ({ icon = "menuMoreVert", className, onClick = () => {}, ...rest }) => (
  <Button
    className={cx(styles.root, className)}
    icon-prefix={icon}
    iconSize="20"
    onSIClick={onClick}
    variant="icon"
    {...rest}
  />
);

export default ContextButton;
